import { reactive } from "vue";

export default reactive({ flashMessage: "", event: null });
